import type { IconSvgObject } from './types';

const NotificationOff02Icon: IconSvgObject = [
  ["path", { d: "M18 18H3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 20C13.5 20.8284 12.8284 21.5 12 21.5M10.5 20C10.5 20.8284 11.1716 21.5 12 21.5M12 21.5V20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 18V9.5C5 8.20839 5.34981 6.99849 5.95987 5.95987M7.85707 3.85707C9.01706 3.00399 10.4497 2.5 12 2.5C15.866 2.5 19 5.63401 19 9.5V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default NotificationOff02Icon;
